import { Component, OnInit } from '@angular/core';
import { VideoSDKMeeting} from '@videosdk.live/rtc-js-prebuilt';
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs';
import { SharedService } from '../../shared/shared.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';



@Component({
  selector: 'app-video-call',
  templateUrl: './video-call.component.html',
})
export class VideoCall implements OnInit {
  public apiKey: string = '';
  public apiToken: string = '';
  public meeting: any  = null;
  public urlBody: string = '';
  public baseUrl: string = 'https://videosdk.smartdataautomation.com/';
  public finalUrl: SafeResourceUrl;
  private subscription: Subscription;

  constructor(
    private _sharedService:SharedService,
    private sanitizer: DomSanitizer
  ){
    this.apiKey = environment.VIDEOSDK_API_KEY;
    this.apiToken = environment.VIDEOSDK_API_TOKEN;
  }

  ngOnInit() {
    this.subscription =  this._sharedService.videocall$.subscribe((action) => {
      if (action) {
        const { meeting_id, name_user ,recording} = action;
        this.createUrl(meeting_id,name_user,recording); 
      }
    });
  }

  createUrl(meeting_id:string,name_user: string,recording:boolean){
    this.urlBody = '?joinScreenEnabled=true&micEnable=true&webcamEnabled=true&pollEnabled=false&whiteboardEnabled=false&raiseHandEnabled=false&screenShareEnabled=false&chatEnabled=false&participantCanEndMeeting=true&canToggleVirtualBackground=true&participantCanEndMeeting=true&participantCanToggleSelfWebcam=true&participantCanToggleSelfMic=true&theme=LIGHT&language=es' 
    +'&name=' + name_user + '&meetingId=' + meeting_id + '&autoStartRecording=' + recording +'&token=' + this.apiToken 
    +'&type=["beta","beta1","beta2","beta3","beta4","beta5"]&imageUrl=https://habitante.s3.us-east-1.amazonaws.com/CobranzasBeta/videocall';  

    const unsafeUrl = this.baseUrl + this.urlBody; 
    this.finalUrl = this.sanitizer.bypassSecurityTrustResourceUrl(unsafeUrl);
  }


}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/video-call/video-call.component.ts